module.exports = __webpack_public_path__ + "img/facial_hair_mustache_thin_mask.0f51ea18.png";